import {
  date,
  enum_,
  type InferOutput,
  nullable,
  number,
  object,
  optional,
  pipe,
  string,
  transform,
  array,
  picklist
} from 'valibot'

import { REPORT_SEARCH_MODE } from '@/features/shared/models'
import { MONTHLY_TOUR_REPORT_STATUS } from '@/libs/api/types'

const dateToStringSchema = pipe(
  nullable(date()),
  // Date型だった場合stringに変換
  transform((v) => (v instanceof Date ? v.toISOString() : null)),
  string()
)

const searchModeSchema = picklist([
  REPORT_SEARCH_MODE.MONTH_RANGE,
  REPORT_SEARCH_MODE.DATE_RANGE
])

// MonthlyTourReportSearchForm用のSchema (dateToString)
export const MonthlyTourReportSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  status: optional(enum_(MONTHLY_TOUR_REPORT_STATUS)),
  dcIds: optional(array(number())),
  partnerId: optional(number()),
  operatingYearMonthFrom: optional(dateToStringSchema), // 運行月 from
  operatingYearMonthTo: optional(dateToStringSchema), // 運行月 to
  // 検索モード (#4421)。未指定は月単位として扱う
  searchMode: optional(searchModeSchema),
  operatingDateFrom: optional(dateToStringSchema), // 計上日 from
  operatingDateTo: optional(dateToStringSchema) // 計上日 to
})

export type MonthlyTourReportSearch = InferOutput<
  typeof MonthlyTourReportSearchSchema
>

// validateSearch用のschema (non-transform)
export const MonthlyTourReportSearchValidateSchema = object({
  page: optional(number()),
  take: optional(number()),
  status: optional(enum_(MONTHLY_TOUR_REPORT_STATUS)),
  dcIds: optional(array(number())),
  partnerId: optional(number()),
  operatingYearMonthFrom: optional(string()), // 運行月 from
  operatingYearMonthTo: optional(string()), // 運行月 to
  searchMode: optional(searchModeSchema), // 検索モード (#4421)
  operatingDateFrom: optional(string()), // 計上日 from
  operatingDateTo: optional(string()) // 計上日 to
})

/**
 * 運行年月 from/to が未指定で、初期値（前月〜当月）の補完が必要かどうかを判定する。
 *
 * 運行年月 from/to は BE で必須 (`MonthlyTourReportListSearchOptionDto`) のため、未指定のまま
 * 一覧 API を叩くと 400 Bad Request になる。拠点プルダウン切替で `dcIds` のみを送信し
 * from/to が欠落するケース (#4128) もこの判定で補完対象とし、beforeLoad の redirect で
 * 既定の運行年月を付与する。
 */
export const needsOperatingYearMonthDefault = (search: {
  dcIds?: number[] | null
  operatingYearMonthFrom?: string | null
  operatingYearMonthTo?: string | null
}): boolean => !search.operatingYearMonthFrom && !search.operatingYearMonthTo
